export const over = [
    {
        id: 1,
        name: "Երկաթե մեխի պղնձապատումը",
        info: "https://www.youtube.com/watch?v=SWDJvmmqU90",
        menuItemId: 4
    },
    {
        id: 2,
        name: "Թորման միջոցով համասեռ խառնուրդի",
        info: "https://www.youtube.com/watch?v=Ezjg79ATjmw",
        menuItemId: 4
    },
    {
        id: 3,
        name: "Մալաքիտի քայքայումը",
        info: "https://www.youtube.com/watch?v=7fbyjfMiMlY",
        menuItemId: 4
    },
    {
        id: 4,
        name: "Պղնձի օքսիդացումը փակ և բաց համակարգերում ",
        info: "https://youtu.be/9onZKaLpdpo ",
        menuItemId: 4
    },
    {
        id: 5,
        name: "Փոխանակման ռեակցիա ",
        info: "https://youtu.be/FA0WaBn6zmM ",
        menuItemId: 4
    },



];
